import React from "react";
import moment from "moment";
import {areMomentsEqualToDay} from "../../utils/date-utils";

interface DayViewProps {
  day: moment.Moment;
}

class DayView extends React.Component<DayViewProps, any> {

  public render(): React.ReactNode {
    const {day} = this.props;

    const dayNumber = day.format("DD");
    const dayName = day.format("dddd").toUpperCase();
    const isToday = areMomentsEqualToDay(day, moment());

    return (
      <div className="calendar-day-view">
        <span className={`day-name ${isToday && 'highlighted'}`}>{dayName}</span>
        <div className={`day-number ${isToday && 'highlighted'}`}>{dayNumber}</div>
      </div>
    );
  }
}

export default DayView;


// WEBPACK FOOTER //
// ./src/event/view/DayView.tsx